import { appPublicUrl, brandLogo, brandLogoSmall } from 'consts'
import getPages from 'utils/getPages'
import { roles } from 'consts'
import { getCustomData } from 'shared/components/App/Auth'
import { getAppViewMode } from "shared/components/App/Auth"
import { IonIcon } from '@ionic/react'
import { menu } from 'ionicons/icons'

const getBrandContent = () => {

  let homePath = '/'
  const pages = getPages()
  const page = pages.find(item => {
    return item?.path && item.path.length &&
      item?.roles && item.roles.includes(roles.superAdmin)
  })

  const customer = getCustomData('customer') ?? false
  const customerName = customer?.display_name ?? false

  if ((typeof page !== 'undefined') && (typeof page.path === 'string')) {
    homePath = page.path
  }

  return (
    <>
      <div className='logo'>
        <img src={appPublicUrl + brandLogo} alt='Application Logo' />
        <img src={appPublicUrl + brandLogoSmall} className="fold-show" alt='Application Logo - Smaller' />
        {(getAppViewMode() == 'user') && customerName && <p>{customerName}</p>}
      </div>
      <IonIcon icon={menu} className='ionicon fold-show fold-icon' style={{ fontSize: '16px' }} />
    </>
  )
}

export default getBrandContent
